export enum MassCodingActivityType {
  General = 1,
  MassImport = 2,
  UpdateProgram = 3,
  SetSharedWorkspaceRooms = 4,
  PublishReadyForETMFDocuments = 5,
  LinkTopics = 6,
  UnlinkTopics = 7,
  SSUBulkUpdate = 8,
}
